import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// NOTE: We intentionally do not wrap in <React.StrictMode>. The Daily.co
// SDK enforces a single global call instance; StrictMode's dev-only
// double-mount of effects causes "Duplicate DailyIframe instances are not
// allowed". Production behaviour is unaffected (StrictMode is a dev-only
// concern).
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
